// extracted by mini-css-extract-plugin
export default {"container":"QRCode_container__Uas0O","codeContainer":"QRCode_codeContainer__+bG27","code":"QRCode_code__z6Wuw","text":"QRCode_text__m4exY"};